namespace appn.views.provider.security {

    class InitArgs {
        passwordPolicies: any = [];
        twoFactorAuthAppUrlMap: Dictionary<string> = {};
        ipRuleModes: Array<SelectListItem> = [];
        ipWhitelistDataSources: Array<SelectListItem> = [];
    }
    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();
    }

    function addEvents() {
        $('.btn-showPolicies').on('click', function(e) {
            e.preventDefault();

            let policyHtml = appn.emptyString;

            for (const policy of _initArgs.passwordPolicies) {
                policyHtml += '<b>' + T(policy.name) + '</b><br>';
                policyHtml += T(policy.description) + '<br>';
                policyHtml += '<ul class="pl-15">';

                const reqStr = T((policy as any).requirements, policy.minChars, policy.maxChars);
                for (const req of reqStr.split('\n'))
                    policyHtml += '<li>' + req + '</li>';

                policyHtml += '</ul><br>';
            }

            appn.dialog.alert({
                modalColor: 'modal-info',
                title: T('Password Policies'),
                buttons: {
                    ok: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                message: policyHtml,
                autoHeaderIcon: false
            });
        });

        $(document).on('click', '.addIpRule', function(event) {
            event.preventDefault();

            if ($('#ipRulesTable tbody').children().length === 0) {
                $('#ipRulesTable').show();
                $('.addIpRule').css('top', '0px');
            }

            const idx = $('#ipRulesTable tbody').children().length;

            const newRow = `<tr>` +
                `<td class="dataCol ruleName"><input class="form-control form-control-sm" type="text" name="Provider.ProviderConfig.IPWhitelist[${idx}].Name"></td>` +
                `<td class="dataCol ruleApplyTo">${appn.elementBuilder.buildSelect(_initArgs.ipRuleModes, `Provider_ProviderConfig_IPWhitelist_${idx}__Mode`, 'ipWhitelistModes form-control-sm', '', `Provider.ProviderConfig.IPWhitelist[${idx}].Mode`)}${appn.elementBuilder.buildSelect(_initArgs.ipWhitelistDataSources, `Provider_ProviderConfig_IPWhitelist_${idx}__EntityId`, 'd-none ipWhitelistDataSources form-control-sm', '', `Provider.ProviderConfig.IPWhitelist[${idx}].EntityId`)}</td>` +
                `<td class="dataCol ruleFromIP"><input class="form-control form-control-sm" type="text" name="Provider.ProviderConfig.IPWhitelist[${idx}].FromIP"></td>` +
                `<td class="dataCol ruleToIP"><input class="form-control form-control-sm" type="text" name="Provider.ProviderConfig.IPWhitelist[${idx}].ToIP"></td>` +
                `<td class="closeCell">${elementBuilder.buildBtnRemoveRow('delete_button_ipRule', 'data-tablename="ipRulesTable"')}</td>` +
                `</tr>`;

            $('#ipRulesTable tbody').append(newRow);

            select.init({
                selector: '#ipRulesTable tbody tr:last-child select'
            });
        });

        $(document).on('click', '.delete_button_ipRule', function() {
            const tableName = $(this).attr('data-tablename');
            $(this).parents('tr').remove();

            renameRows(tableName as string);

            select.init({
                selector: '#ipRulesTable tbody tr select'
            });

            if ($('#ipRulesTable tbody').children().length === 0) {
                $('#ipRulesTable').hide();
                $('.addIpRule').css('top', '-20px');
            }
        });

        $(document).on('change', '.ipWhitelistModes', function() {
            const selectedMode = $(this).val() as string;
            const ipWhitelistDataSources = $(this).closest('.dataCol').find('.ipWhitelistDataSources');
            const tr = $(this).closest('tr');
            const idx = tr.index();

            if (selectedMode === 'ApiDataSource') {
                // Set to choose
                const firstDsInList = ipWhitelistDataSources.find('option').eq(1);
                ipWhitelistDataSources.val(firstDsInList.attr('value') as string);
                ipWhitelistDataSources.trigger('change');
                $(this).next().removeClass('d-none').addClass('d-none');
                ipWhitelistDataSources.next().removeClass('d-none');
                ipWhitelistDataSources.removeClass('d-none');

                select.init({
                    selector: `#Provider_ProviderConfig_IPWhitelist_${idx}__EntityId`
                });

                return;
            }

            $(this).removeClass('d-none');
            ipWhitelistDataSources.removeClass('d-none').addClass('d-none');
        });

        $(document).on('change', '.ipWhitelistDataSources', function() {
            const selectedDs = $(this).val() as string;
            const ipWhitelistModes = $(this).closest('.dataCol').find('.ipWhitelistModes');

            if (selectedDs === emptyGuid) {
                ipWhitelistModes.val('Disabled').trigger('change');

                $(this).next().removeClass('d-none').addClass('d-none');
                ipWhitelistModes.next().removeClass('d-none');
                return;
            }

            $(this).next().removeClass('d-none');
            ipWhitelistModes.next().removeClass('d-none').addClass('d-none');
        });

        addTwoFactorAuthEvents();
    }

    function renameRows(tableName: string) {
        if (tableName === 'ipRulesTable')
            renameIpRules();
    }

    function renameIpRules() {
        // rename all remaining rows to keep continuous index

        $('#ipRulesTable tbody tr').each(function(index, row) {
            $(this).find('.ruleName input')
                .attr('name', `Provider.ProviderConfig.IPWhitelist[${index}].Name`)
                .attr('id', `Provider_ProviderConfig_IPWhitelist_${index}__Name`);

            $(this).find('.ruleApplyTo .ipWhitelistModes')
                .attr('name', `Provider.ProviderConfig.IPWhitelist[${index}].Mode`)
                .attr('id', `Provider_ProviderConfig_IPWhitelist_${index}__Mode`);

            $(this).find('.ruleApplyTo .ipWhitelistDataSources')
                .attr('name', `Provider.ProviderConfig.IPWhitelist[${index}].EntityId`)
                .attr('id', `Provider_ProviderConfig_IPWhitelist_${index}__EntityId`);

            $(this).find('.ruleFromIP input')
                .attr('name', `Provider.ProviderConfig.IPWhitelist[${index}].FromIP`)
                .attr('id', `Provider_ProviderConfig_IPWhitelist_${index}__FromIP`);

            $(this).find('.ruleToIP input')
                .attr('name', `Provider.ProviderConfig.IPWhitelist[${index}].ToIP`)
                .attr('id', `Provider_ProviderConfig_IPWhitelist_${index}__ToIP`);
        });
    }

    function addTwoFactorAuthEvents() {
        $('#Provider_ProviderConfig_TwoFactorAuthConfig_Mode').on('change', function(event: any) {
            const selectedVal = $(this).val() as string;

            if (selectedVal === TwoFactorAuthMode.Disabled) {
                $('.form-group-preferredApp,.form-group-otherNameAndUrl,.form-group-verifyInterval').removeClass('d-none').addClass('d-none');
                return;
            }

            $('.form-group-preferredApp,.form-group-verifyInterval').removeClass('d-none');

            const selectedPreferredAppVal = $('.select-preferredApp').val() as string;
            showHideTwoFaUrlAndOther(selectedPreferredAppVal);
        });

        $('.select-preferredApp').on('change', function(event: any) {
            const selectedVal = $(this).val() as string;
            showHideTwoFaUrlAndOther(selectedVal);
        });
    }

    function showHideTwoFaUrlAndOther(selectedVal: string) {
        if (selectedVal === TwoFactorAuthPreferredApp.Other) {
            $('.form-group-otherNameAndUrl').removeClass('d-none');
            $('.btn-downloadAuthApp').removeClass('d-none').addClass('d-none');
            return;
        }

        if (selectedVal === TwoFactorAuthPreferredApp.None) {
            $('.btn-downloadAuthApp').removeClass('d-none').addClass('d-none');
            $('.form-group-otherNameAndUrl').removeClass('d-none').addClass('d-none');
            return;
        }

        $('.form-group-otherNameAndUrl').removeClass('d-none').addClass('d-none');
        $('.btn-downloadAuthApp').attr('href', _initArgs.twoFactorAuthAppUrlMap[selectedVal]).removeClass('d-none');
    }
}
